/**
 * The place where most of the custom JavaScript should be found.
 */



/**
 * Gallery filter
 */
 ;( () => {
    const filterForm = document.querySelector( 'form[name="gallery-filter"]' )

    if ( ! filterForm ) return

    const select = filterForm.querySelector( 'select' )

        select.addEventListener( 'change', e => {
            
            let value = select.value

            let newUrl = new URL( window.location.href )

            let newGalleryUrl = new URL( `/gallery/${ value !== 'All' ? value + '/' : '' }`, newUrl )

            newUrl = newGalleryUrl


            window.location.href = newUrl

        })

})();



/**
 * Archive Blog Filter
 */
 ;( () => {
    const orderingForm = document.querySelector( '#archive-blog__sort-by' )

    orderingForm?.arrangeby?.addEventListener( 'change', () => {
        orderingForm.submit()
    })
})();



/**
 * Setting min date for property enquiry form on hero front page
 */
;( () => {
    const dateInput = document.querySelector( '#shiftr_form_52_date' );

    if( !dateInput ) return

    const todaysDate = new Date().toISOString().split('T')[0]

    dateInput.setAttribute( 'min', todaysDate )

})();


/**
 *  Property Booking form
 */
;( () => {
    /**
     * Get all the links that include 'booking-form' and append a search param of the current page
     * pathname
     * 
     * propertyTerm - declared via single-property.php
     */
    let bookNowBtns = document.querySelectorAll( 'a[href*="booking-form"' )

    if( !bookNowBtns ) { return }

    let url = window.location.pathname;
    let urlCleanup = url.replace( /property/, '' ).replace( /\//g, '' );
    
    bookNowBtns.forEach(element => {
        let href = element.href.concat( '?location_name=', propertyTerm ).concat( '&property_name=', urlCleanup )
        element.href = href;
    });

})();

;( () => {

    /**
     * getting the search param 'location' and 'property' and auto selecting the relevant fields
     */
    let param = new URLSearchParams( window.location.search );
    let location = param.get( 'location_name' )
    let property = param.get( 'property_name' )

    if( location == null && property == null ) { return }

    let locationSelect = document.querySelector( '.field-location select' )
    let buildingSelect = document.querySelector( '.field-building select' )

    locationSelect.value = location
    buildingSelect.value = property


})();



/**
 * Back Button
 */
;( () => {

    const backButton = document.querySelector( '#jsBackButton' )

    if( !backButton ) return

    backButton.addEventListener( 'click', function( event ) {  
        event.preventDefault()
        window.history.back()
    })
})();
